module.exports = __webpack_public_path__ + "static/media/golf_masters_popup.8199f333.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/golf_masters_popup.png
// module id = 700
// module chunks = 0